import axiosInstance from "../utils/axios";

export const getFulfilments = async (
  page,
  size,
  sortValue,
  sortType,
  searchCol,
  searchText,
  fromDate,
  toDate
) => {
  try {
    const res = await axiosInstance.get("api/fulfilment/search", {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        page: page,
        size: size,
        sortBy: sortValue,
        orderBy: sortType,
        searchKey: searchCol,
        searchValue: searchText,
      },
      withCredentials: true,
    });

    return res.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const exportFulfilments = async (
  searchCol,
  searchText,
  fromDate,
  toDate
) => {
  try {
    const res = await axiosInstance.post(
      "api/fulfillments/export",
      {
        headers: {
          accept: "text/csv",
        },
        withCredentials: true,
      },
      {
        params: {
          fromDate: fromDate,
          toDate: toDate,
          searchKey: searchCol,
          searchValue: searchText,
        },
      }
    );

    return res.data;
  } catch (error) {
    return error;
  }
};

export const updateFulfilments = async () => {
  try {
    const res = await axiosInstance.get("api/fulfilment/update", {
      withCredentials: true,
    });
    return res.data;
  } catch (error) {
    return error;
  }
};
